import { Routes } from '@angular/router';
const ɵ0 = () => import("./world-ranking-statistics/app.module.ngfactory").then(m => m.AppModuleNgFactory), ɵ1 = () => import("./calendar/app.module.ngfactory").then(m => m.AppModuleNgFactory), ɵ2 = () => import("./indoor-module/app.module.ngfactory").then(m => m.AppModuleNgFactory), ɵ3 = () => import("./calendar/app.module.ngfactory").then(m => m.AppModuleNgFactory), ɵ4 = () => import("./calendar/app.module.ngfactory").then(m => m.AppModuleNgFactory), ɵ5 = () => import("./results/app.module.ngfactory").then(m => m.AppModuleNgFactory), ɵ6 = () => import("./rulebook/app.module.ngfactory").then(m => m.AppModuleNgFactory), ɵ7 = () => import("./members/members.module.ngfactory").then(m => m.MembersModuleNgFactory), ɵ8 = () => import("./members/members.module.ngfactory").then(m => m.MembersModuleNgFactory), ɵ9 = () => import("./athletes/athletes.module.ngfactory").then(m => m.AthletesModuleNgFactory), ɵ10 = () => import("./competitions/competitions.module.ngfactory").then(m => m.CompetitionsModuleNgFactory), ɵ11 = () => import("./competitions/competitions.module.ngfactory").then(m => m.CompetitionsModuleNgFactory), ɵ12 = () => import("./ranking-tabs/ranking-tabs.module.ngfactory").then(m => m.RankingTabsModuleNgFactory);
const routes = [
    {
        path: "",
        loadChildren: ɵ0
    },
    {
        path: "",
        loadChildren: ɵ1
    },
    {
        path: "events/indoor",
        loadChildren: ɵ2
    },
    {
        path: "world-cup-ranking",
        redirectTo: 'ranking/world-cup-ranking',
        pathMatch: 'full'
    },
    {
        path: "world-ranking",
        redirectTo: 'ranking/world-ranking',
        pathMatch: 'full'
    },
    {
        path: "prize-precision",
        redirectTo: 'ranking/prize-precision',
        pathMatch: 'full'
    },
    {
        path: "classement-mondial",
        redirectTo: 'ranking/classement-mondial',
        pathMatch: 'full'
    },
    {
        path: "classements-coupe-du-monde",
        redirectTo: 'ranking/classements-coupe-du-monde',
        pathMatch: 'full'
    },
    {
        path: "prix-precision",
        redirectTo: 'ranking/prix-precision',
        pathMatch: 'full'
    },
    {
        path: "events/calendar",
        loadChildren: ɵ3
    },
    {
        path: "calendar",
        loadChildren: ɵ4
    },
    {
        path: "events/results",
        loadChildren: ɵ5
    },
    {
        path: "rulebook",
        loadChildren: ɵ6
    },
    {
        path: 'members',
        loadChildren: ɵ7
    },
    {
        path: 'membres',
        loadChildren: ɵ8
    },
    { path: 'member', loadChildren: './members/details-page/details-page.module#DetailsPageModule' },
    { path: 'athlete/photos/:id', redirectTo: 'profile/photos/:id', pathMatch: 'full' },
    { path: 'athlete/:id', redirectTo: 'profile/:id', pathMatch: 'full' },
    { path: 'athlete/:id/:name', redirectTo: 'profile/:id/:name', pathMatch: 'full' },
    { path: 'athlete/:id/:name/results', redirectTo: 'profile/:id/:name/results', pathMatch: 'full' },
    { path: 'athlete/:id/:name/biography', redirectTo: 'profile/:id/:name/biography', pathMatch: 'full' },
    { path: 'athlete/:id/:name/statistics', redirectTo: 'profile/:id/:name/statistics', pathMatch: 'full' },
    { path: 'athlete/:id/:name/photos', redirectTo: 'profile/:id/:name/photos', pathMatch: 'full' },
    { path: 'athlete/:id/:name/news', redirectTo: 'profile/:id/:name/news', pathMatch: 'full' },
    { path: 'athlete/:id/:name/matches', redirectTo: 'profile/:id/:name/matches', pathMatch: 'full' },
    { path: 'athletes', loadChildren: ɵ9 },
    { path: 'officials', loadChildren: './officials/officials.module#OfficialsModule' },
    { path: 'coaches', loadChildren: './coaches/coaches.module#CoachesModule' },
    { path: 'profile', loadChildren: './athlete/athlete.module#AthleteModule' },
    { path: 'profile/photos/:id', loadChildren: './athlete/athlete.module#AthleteModule' },
    { path: 'profile/:id', loadChildren: './athlete/athlete.module#AthleteModule' },
    { path: 'profile/:id/:name', loadChildren: './athlete/athlete.module#AthleteModule' },
    { path: 'competition/:id/:name', loadChildren: ɵ10 },
    { path: 'competition/:id', loadChildren: ɵ11 },
    { path: 'entry/:id', redirectTo: 'athlete/:id', pathMatch: 'full' },
    { path: 'rankings', loadChildren: ɵ12 },
    { path: 'rankings', redirectTo: 'rankings/world-ranking' },
    { path: 'ranking', redirectTo: 'rankings/world-ranking' },
    { path: 'ranking/world-ranking', redirectTo: 'rankings/world-ranking' },
    { path: 'ranking/world-cup-ranking', redirectTo: 'rankings/world-cup-ranking' },
    { path: 'ranking/prize-precision', redirectTo: 'rankings/prize-precision' },
    { path: 'rankings/longines-prize-precision', redirectTo: 'rankings/prize-precision' },
    { path: 'ranking/world-ranking', redirectTo: 'rankings/world-ranking' },
    { path: 'ranking/world-cup-ranking', redirectTo: 'rankings/world-cup-ranking' },
    { path: 'ranking/prix-precision', redirectTo: 'ranking/prix-precision' },
    { path: 'ranking/prix-longines-precision', redirectTo: 'rankings/prix-precision' },
    { path: 'ranking/classement-mondial', redirectTo: 'rankings/classement-mondial' },
    { path: 'ranking/classements-coupe-du-monde', redirectTo: 'rankings/classements-coupe-du-monde' },
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12 };
